import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/encounter";
const API_PATH_2 = ConstantList.API_EN_POINT + "/product";
export const pagingExamEnc = (searchObject) =>
  axios.post(API_PATH + "/paging-exam-encounter", searchObject);
export const pagingTreatmentSheet = (searchObject) =>
  axios.post(API_PATH + "/paging-treatment-sheet", searchObject);

export const getListSurgeryEncounter = (obj) => {
  return axios.post(API_PATH + "/get-list-surgery", obj);
};

export const saveSurgeryEncounter = (obj) => {
  return axios.post(API_PATH + "/save-surgery-encounter", obj);
};

export const deleteSurgeryEncounter = (id) => {
  return axios.delete(API_PATH + "/delete-surgery-encounter/" + id);
};

export const getListProcedureEncounter = (obj) => {
  return axios.post(API_PATH + "/get-list-procedure", obj);
};
export const saveProcedureEncounter = (obj) => {
  return axios.post(API_PATH + "/save-procedure-encounter", obj);
};

export const deleteProcedureEncounter = (id) => {
  return axios.delete(API_PATH + "/delete-procedure-encounter/" + id);
};

export const pagingEncounterByRoom = (searchObject) =>
  axios.post(API_PATH + "/search-page-by-room", searchObject);

export const getMediPrint = (mediRequestForm) =>
  axios.post(API_PATH + "/get-medi-req-print", mediRequestForm);

export const getSupplyPrint = (mediRequestForm) =>
  axios.post(API_PATH + "/get-medical-supply-request-print", mediRequestForm);

export const cancelExecutionStatus = (encounterId) =>
  axios.get(API_PATH + "/cancel-execution-status/" + encounterId);

export const getVitaSignsByVisits = (obj) =>
  axios.post(API_PATH + "/get-vita-signs-by-visits", obj);

export const saveProductRequest = (obj) => {
  return axios.post(API_PATH_2 + "/save-drug", obj);
};

export const saveMedicalRequest = (obj) => {
  return axios.post(API_PATH_2 + "/save-medical-supply", obj);
};

export const getEncounterDiagnosis = (obj) => {
  return axios.post(API_PATH + "/get-diagnosis", obj);
};

export const saveEncounterDiagnosis = (obj) => {
  return axios.post(API_PATH + "/save-diagnosis", obj);
};

export const lockProduct = (id) => {
  return axios.post(API_PATH_2 + "/lock-product/" + id);
};
